import makeStyles from '@material-ui/core/styles/makeStyles'

export const useStyles = makeStyles({
    root: {
        display: 'flex'
    },
    goRight: {
        marginLeft: 'auto'
    }
})